export default "__VITE_ASSET__Bogwl2Dj__"